import { Node } from 'rete'

import { ChannelInfo } from '../../../../../../../../../../models/CheckChannels/CheckChannels'
import { BaseFlowButtonWithOutput } from '../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons/FlowButtons/BaseFlowButtonWithOutput'
import MessageEditorWithMediaData from '../../../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import { SocketsActionsTypes } from '../../../../../../../components'
import CustomEditor from '../../../../../../Editor/CustomEditor'
import ChannelsInfoHelper from '../../../../../../Helpers/ChannelsInfoHelper'
import { ActionNode } from '../../ActionNode'
import { ActionNodeActionProxy } from '../index'
import { NotifyGroupAction } from './NotifyGroupAction'

export class NotifyGroupActionProxy extends ActionNodeActionProxy {
  action: NotifyGroupAction
  errorChannelInfo: string | null = null

  private socketsActions: SocketsActionsTypes

  constructor(action: NotifyGroupAction, socketsActions: SocketsActionsTypes) {
    super()
    this.action = action

    this.socketsActions = socketsActions

    action.variants[0]?.buttons.forEach((r) => r.forEach((b) => {
      if (b instanceof BaseFlowButtonWithOutput && b.output && !this.socketsActions.checkOutput(b.output)) {
        this.socketsActions.createOutput(b.output)
      }
    }))
  }

  getModel(): NotifyGroupAction {
    return this.action
  }

  get channelInfo(): ChannelInfo | undefined {
    if (this.action.group) {
      return ChannelsInfoHelper.GetChannel(this.action.group.toString())
    }

    if (this.errorChannelInfo) {
      return ChannelsInfoHelper.GetChannel(this.errorChannelInfo)
    }

    return undefined
  }

  setChannel(id: number): void {
    this.errorChannelInfo = null
    this.action.group = id
  }

  setErrorChannel(value: string): void {
    this.action.group = null
    this.errorChannelInfo = value
  }

  /**
   * Булев флаг передается для переиспользования этого класса в ноде отправки сообщения,
   * там сокеты создаются в классе ProxyUserInputAction
   * */
  setMessages(messages: Array<MessageEditorWithMediaData>, createSockets: boolean, node: ActionNode, editor: CustomEditor): void {
    if (createSockets) {
      this.createOutputs(messages, node, editor)
    }

    this.action.variants = messages
  }

  async createOutputs(messages: Array<MessageEditorWithMediaData>, node: ActionNode, editor: CustomEditor): Promise<void> {
    const availableButtons: Array<BaseFlowButtonWithOutput> = []
    const movedSockets: Array<number> = []

    this.action.variants[0]?.buttons.forEach((r) => r.forEach((b) => {
      if (b instanceof BaseFlowButtonWithOutput) {
        availableButtons.push(b)
      }
    }))

    messages[0]?.buttons.forEach((r) => r.forEach((b) => {
      if (b instanceof BaseFlowButtonWithOutput) {
        const isExistButton = availableButtons.find((ab) => ab.guid === b.guid )

        if (isExistButton && isExistButton.output) {
          b.output = isExistButton.output

          availableButtons.splice(availableButtons.indexOf(isExistButton), 1)

          this.socketsActions.switchIsMoved(b.output, true)
          movedSockets.push(b.output)
        } else {
          b.output = this.socketsActions.createOutput()
        }
      }
    }))

    requestAnimationFrame(() => movedSockets.forEach((id) => this.socketsActions.switchIsMoved(id, false)))

    requestAnimationFrame(() => {
      // eslint-disable-next-line sonarjs/no-identical-functions
      availableButtons.forEach((b) => {
        if (b.output) {
          this.socketsActions.deleteOutput(b.output)
        }
      })
    })

    await node.update()
    editor.view.updateConnections({ node: node as unknown as Node })
  }
}
